// Get the correct image path based on hostname
export const getImagePath = (imagePath) => {
  const hostname = window.location.hostname;

  // Remove leading slash if exists to avoid double slashes
  const cleanPath = imagePath.startsWith('/') ? imagePath.substring(1) : imagePath;
  return `/QikERP/${cleanPath}`;
};

export const isLive = () => {
  let hostName = (window.location.hostname).toLowerCase();
  if (hostName.includes("qikerp.com")) {
    return true;
  }
  return false;
};

export const isFlashOfferOn = () => {
  try {
      // return true

    const allDataRaw = localStorage.getItem('allData');
    if (!allDataRaw) return false;
    const allData = JSON.parse(allDataRaw);
    const sinceDTStr = allData?.sinceDTStr;
    if (!sinceDTStr) return false;

    const now = new Date();
    const currentHour = now.getHours();

    const isEveningWindow = currentHour >= 20 && currentHour < 24;
    if (!isEveningWindow) return false;

    const leadDate = new Date(sinceDTStr.replace(' ', 'T'));
    const todayAt6PM = new Date(now);
    todayAt6PM.setHours(18, 0, 0, 0);
    const yesterdayAt6PM = new Date(todayAt6PM);
    yesterdayAt6PM.setDate(yesterdayAt6PM.getDate() - 1);

    return leadDate >= yesterdayAt6PM && leadDate <= todayAt6PM;


  } catch {
    return false;
  }
};

export const isSundayOffer = () => {
  try {

    const allDataRaw = localStorage.getItem('allData');
    if (!allDataRaw) return false;
    const allData = JSON.parse(allDataRaw);
    const sinceDTStr = allData?.sinceDTStr;
    if (!sinceDTStr) return false;

    const now = new Date();
    const isSunday = now.getDay() === 0;
    if (!isSunday) return false;

    const leadDate = new Date(sinceDTStr.replace(' ', 'T'));
    const daysSinceSignup = Math.floor((now - leadDate) / (1000 * 60 * 60 * 24));

    return daysSinceSignup >= 16 && daysSinceSignup <= 22;
  } catch {
    return false;
  }
};

export const isIOSMobileDevice = () => {
  try {
    const userAgent = navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod|cpu os/.test(userAgent);
  } catch {
    return false;
  }
};

export const checkLPData = (zParam, searchParams) => {
  const allData = localStorage.getItem('allData');
  const mySrc = localStorage.getItem('mySrc');
  const cio = localStorage.getItem('cio');

  if (!allData || !mySrc || !cio) {
    const i = searchParams.get('i') || '';
    const o = searchParams.get('o') || '';
    const m = searchParams.get('m') || '';

    const mQuery = m ? `&m=${m}` : '';
    const oQuery = o ? `&o=${o}` : '';

    window.location.href = `/QikERP/Guide?i=${i}${oQuery}&z=${zParam}${mQuery}`;
    return false;
  }

  return true;
};